import { Button } from "@material-ui/core";
import BillBody from "./BillBody";
import BillFooter from "./BillFooter";
import BillHeader from "./BillHeader";
import JsPDF from "jspdf";
import html2canvas from "html2canvas";

const Bill = ({ billInfo }) => {
  let billType =
    billInfo.value.bill_water_meter.water_meter_type_info.water_meter_tag_info
      .water_meter_tag_name;

  const downloadBill = () => {
    const options = {
      scrollY: -window.scrollY,
      windowWidth:
        document.documentElement.offsetWidth * window.devicePixelRatio,
      windowHeight:
        document.documentElement.offsetHeight * window.devicePixelRatio,
      useCORS: true,
    };
    const input = document.getElementById("report");
    html2canvas(input, options).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new JsPDF({
        orientation: "landscape",
        unit: "mm",
        format: [210, 148], // A5 paper size in landscape
      });
      pdf.addImage(imgData, "PNG", 0, 0, 210, 148); // Add the image to PDF
      pdf.save(
        `bill_${billInfo.value?.bill_water_meter?.water_meter_name}.pdf`
      );
    });
  };
  return (
    <>
      <div
        className="bill-info"
        id="report"
        style={{ width: "215mm", height: "150mm", margin: "10px auto" }}
      >
        <BillHeader info={billInfo.value} />
        <BillBody info={billInfo.value} type={billType} />
        <BillFooter info={billInfo.value} type={billType} />
      </div>
      <div style={{ margin: "0px auto" }}>
        <Button
          onClick={downloadBill}
          style={{ color: "#fff", margin: "10px 12px" }}
          variant="contained"
          color="primary"
        >
          دانلود قبض
        </Button>
      </div>
    </>
  );
};
export default Bill;
